import React from 'react';
import { AdditionalCharges } from 'AppClient/api/Bookings/BokkingsTypes';

interface Props {
	data: AdditionalCharges | null;
	serviceProviderCurrencySymbol: string;
}
export const AdditionalChargesTCText: React.FC<Props> = props => {
	const { data, serviceProviderCurrencySymbol } = props;

	const getTitle = () => <h5>Additional service partner charges (included in quotation)</h5>;

	const getContent = () => {
		if (!data) {
			return null;
		}

		const bookingFee = data.bookingFee || 0;
		const gratuityFeePercentages = data.gratuityFeePercentages || 0;
		const adminFeePercentages = data.adminFeePercentages || 0;
		const fuelSurchargePercentages = data.fuelSurchargePercentages || 0;
		const discountPercentages = data.discountPercentages || 0;

		return (
			<>
				<p>
					Booking fee:{' '}
					<strong>
						{bookingFee} {serviceProviderCurrencySymbol}
					</strong>
				</p>
				<p>
					Gratuity: <strong>{gratuityFeePercentages}%</strong>
				</p>
				<p>
					Fuel surcharge: <strong>{fuelSurchargePercentages}%</strong>
				</p>
				<p>
					Admin rate: <strong>{adminFeePercentages}%</strong>
				</p>
				<p>
					Discount: <strong>{discountPercentages}%</strong>
				</p>
			</>
		);
	};

	return (
		<>
			{getTitle()}
			{getContent()}
		</>
	);
};
